module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_WoodMatted.e5051810.jpg";